import styled, { css, keyframes } from 'styled-components';

import { pxToRem } from 'utils/scss';

const fadeIn = keyframes`
  from {
    width:0;
  }

  to {
    width: ${pxToRem(516)};
  }
`;

export const SideBarWrapper = styled.div`
  margin-right: -${pxToRem('20px')};
  height: ${props => (props.type === 'small' ? pxToRem('835px') : '100%')};
  background-color: white;
  transform: translate(${pxToRem('10px')}, -${pxToRem('120px')});
  animation: ${fadeIn} 400ms forwards;
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ItemContainer = styled.div`
  margin-bottom: ${pxToRem('10px')};
`;

export const AddButtonWrapper = styled.button`
  background: white;
  min-width: ${pxToRem('48px')};
  margin-left: ${pxToRem('10px')};
  text-transform: uppercase;
  border: none;
  position: absolute;
  right: ${pxToRem('0px')};
  padding: ${pxToRem('8px')} ${pxToRem('20px')};
  border-radius: ${pxToRem('24px')} ${pxToRem('0px')} ${pxToRem('0px')}
    ${pxToRem('24px')};
  box-shadow: ${pxToRem('11px')} ${pxToRem('11px')} ${pxToRem('22px')} -${pxToRem(
      '5px'
    )} rgba(7, 11, 21, 0.08);
  background-color: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const ContentWrapper = styled.div`
  display: flex;
  margin-top: ${pxToRem('24px')};
  position: relative;
`;

export const TableContainer = styled.div`
  flex: 1;
  position: relative;
`;

export const InputCorporateWrapper = styled.div`
  border-radius: ${pxToRem('36px')};
  display: flex;
  background-color: ${props => props.theme.colors.white};
  padding: ${pxToRem('8px')};
  min-height: ${pxToRem('72px')};
  align-items: center;

  & > div {
    height: ${pxToRem('56px')};
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:hover:not(:last-child),
    &:active:not(:last-child) {
      background-color: ${props => props.theme.colors.blue.five};
    }
  }
  &:first-child {
    margin-right: ${pxToRem('29px')};
  }
`;

export const InputContainerCorporate = styled.div`
  border-radius: ${pxToRem('36px')};
    //  border: solid ${pxToRem('1px')} rgba(70, 122, 251, 0.56);
  background-color: #fff;
  width: ${pxToRem('406px')};
  display: flex;
  flex-direction: row;
`;

export const SearchWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const SearchButton = styled.div`
  cursor: pointer;
`;

export const IconSearch = styled.span`
  border: none;
  border-radius: 50%;
  text-align: center;
  color: ${props => props.theme.colors.white};
  background: ${props => props.theme.colors.gradient.cta};
  font-size: ${pxToRem('30px')};
  padding: ${pxToRem('8px')};
  aspect-ratio: 1/1;
`;

export const AddIconWrapper = styled.div`
  width: ${pxToRem('32px')};
  height: ${pxToRem('32px')};
  margin: 0 ${pxToRem('16px')} 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${pxToRem('1px')} solid ${props => props.theme.colors.statusGreen};
  border-radius: 50%;
  border-image-slice: 1;
`;

export const PlusIcon = styled.div`
  width: ${pxToRem('12px')};
  height: ${pxToRem('12px')};
  background-image: linear-gradient(45deg, #00d7a3, #00d7ca 54%, #00d7a3);
`;

export const AdvancedSearchButton = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: ${pxToRem('30px')};
  width: ${pxToRem('76px')};
  height: ${pxToRem('76px')};
  background-color: white;
  border-radius: 50%;
  border: solid ${pxToRem('2px')} #f0f0f0;
  box-shadow: 0 ${pxToRem('6px')} ${pxToRem('12px')} -${pxToRem('4px')} ${props => props.theme.colors.black.seven};
`;

export const IconWrapper = styled.div`
  border: none;
  border-radius: 50%;
  color: ${props => props.theme.colors.white};
  background: ${props => props.theme.colors.gradient.cta};
  font-size: ${pxToRem('30px')};
  width: ${pxToRem('56px')};
  height: ${pxToRem('56px')};
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;

  :hover {
    cursor: pointer;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  // align-items: center;
  justify-content: start;
  height: ${pxToRem('72px')};

  ${props =>
    !props.noMargin &&
    css`
      margin: ${pxToRem('20px')} ${pxToRem('0px')};
    `}
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: ${pxToRem('406px')};
  border-radius: ${pxToRem('36px')};
  box-shadow: 0 ${pxToRem('6px')} ${pxToRem('12px')} -${pxToRem('4px')} ${props => props.theme.colors.black.seven};
  border: solid ${pxToRem('2px')} #f0f0f0;
  background-color: ${props => props.theme.colors.white};
  justify-content: space-between;
  align-items: center;
  margin-right: ${pxToRem('30px')};
  padding: ${pxToRem('0px')} ${pxToRem('6px')} ${pxToRem('0px')}
    ${pxToRem('20px')};

  ${props =>
    props.isSideBarOpen === true &&
    css`
      width: ${pxToRem('72px')};
      height: ${pxToRem('72px')};
      border-radius: 50%;
      padding: ${pxToRem('0px')};
    `};
`;

export const DropdownWrapper = styled.div`
  width: ${pxToRem('120px')};
`;

export const InputContainer = styled.div`
  border-radius: ${pxToRem('36px')};
  width: ${pxToRem('406px')};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  box-shadow: 0 ${pxToRem('6px')} ${pxToRem('12px')} -${pxToRem('4px')} ${props => props.theme.colors.black.seven};
  border: solid ${pxToRem('2px')} #f0f0f0;
  background-color: ${props => props.theme.colors.white};
  padding: 0 ${pxToRem('10px')} 0 ${pxToRem('30px')};

  ${props =>
    props.isSideBarOpen === true &&
    css`
      width: ${pxToRem('72px')};
      height: ${pxToRem('72px')};
      border-radius: 50%;
      padding: ${pxToRem('0px')};
      margin-left: ${props.type === 'search' ? pxToRem('52px') : 0};
    `};
`;

export const InputWrapper = styled.input`
  font-size: 1rem;
  flex: 1 0 auto;
  outline: none;
  border: none;
  background: transparent;
  font-family: ${({ theme }) => theme.fontset.opensans};
`;

export const RealativeWrapper = styled.div``;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  object-fit: contain;
  border-radius: ${pxToRem('36px')};
  -webkit-backdrop-filter: blur(${pxToRem('22px')});
  backdrop-filter: blur(${pxToRem('22px')});
  border: solid ${pxToRem('2px')} #f0f0f0;
  background-color: rgba(255, 255, 255, 0.8);
  padding: ${pxToRem('8px')};
  margin: ${pxToRem('0px')} ${pxToRem('15px')};
`;

export const Box = styled.div`
  padding: ${pxToRem('12px')} ${pxToRem('58px')};
  flex-grow: 1;
  text-align: center;
  margin: ${pxToRem('5px')} ${pxToRem('10px')};

  :hover {
    cursor: pointer;
  }

  ${props =>
    props.highlight &&
    css`
      border-radius: ${pxToRem('28px')};
      background-color: ${props.theme.colors.blue.five};
    `}
`;
export const BoxContainer = styled.div`
  text-align: center;
`;

export const Divider = styled.div`
  height: ${pxToRem('1px')};
  background-color: ${props => props.theme.colors.lightGray2};
`;

export const AddContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${pxToRem('20px')};
`;

export const SideButton = styled.div`
  height: ${pxToRem('40px')};
  width: ${pxToRem('40px')};
  border-radius: ${pxToRem('25px')} ${pxToRem('0px')} ${pxToRem('0px')}
    ${pxToRem('25px')};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.white};
  cursor: pointer;
  position: unset;
  right: 0;
  top: -${pxToRem('31px')};
  transform: translate(-90%, 0%);
  z-index: 2;
`;

export const IconBack = styled.span`
  border-radius: 50%;
  border: ${pxToRem('1.2px')} solid ${props => props.theme.colors.aquamarine};
  color: ${props => props.theme.colors.aquamarine};
  text-align: center;
  transform: rotate(90deg);
  padding: ${pxToRem('6px')};
`;

export const DownloadCsvIcon = styled.div`
  border: none;
  width: auto;
  max-width: ${pxToRem('40px')};
  height: ${pxToRem('40px')};
  border-radius: ${pxToRem('27px')};
  text-align: center;
  color: ${props => props.theme.colors.white};
  background: ${props => props.theme.colors.gradient.cta};
  padding: ${pxToRem('8px')};
  font-size: ${pxToRem('24px')};
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  transition: max-width 0.5s, opacity 0.6s;
  -webkit-transition: max-width 0.5s, opacity 0.6s;

  span:nth-child(2) {
    opacity: 0;
    cursor: pointer;
    margin-right: ${pxToRem('10px')};
    white-space: nowrap;
    text-transform: uppercase;
  }

  :hover {
    max-width: ${pxToRem('213px')};
    padding: 0 ${pxToRem('20px')};
    span {
      opacity: 1;
    }
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-top: ${pxToRem('32px')};
`;

export const DownArrow = styled.div`
  width: ${pxToRem('8px')};
  height: ${pxToRem('8px')};
  border: solid ${props => props.theme.colors.white};
  border-width: 0 ${pxToRem('3px')} ${pxToRem('3px')} 0;
  display: inline-block;
  padding: ${pxToRem('3px')};

  transform: ${props =>
    props.upsideDown ? 'rotate(225deg)' : 'rotate(45deg)'};
  -webkit-transform: ${props =>
    props.upsideDown ? 'rotate(225deg)' : 'rotate(45deg)'};
  margin-left: ${pxToRem('8px')};
  transition-duration: 0.5s;
  transition-property: transform;
  -webkit-transition-duration: 0.5s;
  -moz-transition-property: transform;
`;
